import UserStoreLoader from './UserStoreLoader';

export default UserStoreLoader;
